import VehicleClassFilterContainer from './VehicleClassFilterContainer';

export default VehicleClassFilterContainer;
